import React, { useEffect, useState } from 'react';
import { Box, Grid, Button, Typography, TextField, Divider } from '@mui/material';
import CustomTable from '../../components/table/FiananceTable';
import { useDispatch, useSelector } from "react-redux";
import BasicTabs from '../../components/tabs/Tabs3';
import { getuser } from '../../slices/setting';
import SearchButton from '../../components/search/Search';
import { Link } from 'react-router-dom';
import { getfinancier } from '../../slices/finance';

  const columns1 = [
    { id: 'financier_name', label: 'Financier Name', minWidth: 150, align:'start' },
    { id: 'address', label: 'Address', minWidth: 150, align:'center' },
    { id: 'city', label: 'City', minWidth: 250, align:'center' },
    { id: 'action', label: 'Action', minWidth: 50, align:'end', actionType: [{edit: true, delete: true}] },
  ];
  

const FinanceMaster = ({setLoader, show}) => {
  
  const dispatch = useDispatch();

  const settingData = useSelector((state) => state.finance);


  const [users, setUsers] = React.useState([]);


  const userUpData = users?.map((va)=>{
    return{
      ...va,
      created_at: `${(new Date(va.created_at)).getDate()} / ${(new Date(va.created_at)).getMonth()+1} / ${(new Date(va.created_at)).getFullYear()}`,
      status:'Active'
    }
  });


  console.log(settingData);

  React.useEffect(()=>{
    if(settingData){
          setUsers(settingData.financier);
    }
  },[settingData]);

  React.useEffect(()=>{
    setLoader(true)
    dispatch(getfinancier())
    .then(() => {
      setLoader(false);
    })
    .catch(()=>{
      setLoader(false);
    })
  },[])


  return (
    <div className='content' style={{marginLeft: show ? '220px' : '10px'}}>
    <Box>
      <Box>
        <Grid container sx={{ paddingBottom: 2, alignItems:'center' }}>
          <Grid item xs={6} sx={{paddingTop: 0}}>
            <Typography variant='h5'>
             Financiers
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{textAlign: 'end', paddingTop: 0}}>
          <Box sx={{display:'flex', justifyContent:'end', alignItems:'center'}}>
          <SearchButton placeholder="Search User"/>
          <Link to='/finance/createfinancier' style={{textDecoration:'none'}}>
          <Button variant='contained' size='large'>+ Create Financier</Button>
          </Link>
          </Box>
          </Grid>
        </Grid>
      </Box>
      <Box component='div'>
        <Box>
        <CustomTable columns={columns1} setLoader={setLoader} rows={userUpData} />
        </Box>
        </Box>
      </Box> 
    </div>
  );
}

export default FinanceMaster;